<!-- =========================================================================================
  File Name: BookDetail.vue
  Description: Book detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="main-container">
    <div class="vx-row mt-5 mb-2">
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <h1>{{ cyclopediaHelpers.getPreferredName(cyclopedia) }} (ID: {{ cyclopedia.id }})</h1>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <div class="ml-auto" style="width: 65px;">
          <vs-switch
            id="active-switch"
            color="success"
            v-model="workingCyclopedia.active"
            v-on:input="updateCyclopedia"
          >
            <span slot="on">Active</span>
            <span slot="off">Inactive</span>
          </vs-switch>
        </div>
      </div>

    </div>

    <div class="vx-row mt-1">
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <CyclopediaNameAndDescCard :cyclopedia="workingCyclopedia" v-on:cyclopediaUpdated="setCyclopediaCopies" />
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <div class="vx-row">
          <div class="vx-col w-full">
            <CompaniesSelectionCard :cyclopedia="cyclopedia" v-on:cyclopediaUpdated="setCyclopediaCopies" />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <AnalysesListCard :cyclopedia="cyclopedia" />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <DykProductEditorCard :cyclopediaId="cyclopedia.id" />
          </div>
        </div>
        <div class="vx-row mt-6 mb-6 pr-4">
          <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="confirmDeleteCyclopedia">Delete Book</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {cyclopediaHelpers} from '@/models/helpers'
  import CyclopediaNameAndDescCard from './components/CyclopediaNameAndDescCard';
  import CompaniesSelectionCard from './components/CompaniesSelectionCard';
  import AnalysesListCard from './components/AnalysesListCard';
  import DykProductEditorCard from "@/views/content/books/components/DykProductEditorCard";

  export default {
    components: {
      CyclopediaNameAndDescCard,
      CompaniesSelectionCard,
      DykProductEditorCard,
      AnalysesListCard,
    },
    mounted() {
      this.fetchAll();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        isLoading: false,
        cyclopediaHelpers: cyclopediaHelpers,
        cyclopedia: new types.Cyclopedia(),
        workingCyclopedia: new types.Cyclopedia()
      }
    },
    computed: {
      cyclopediaId() {
        return this.$route.query.id || null;
      },
      activeBool() {
        return this.workingCyclopedia.active === 1;
      },
      defaultLanguageId() {
        return Number(this.$route.query.lang) || null;
      },
      howManyUnsavedChanges() {
        let count = 0;
        let keys = Object.keys(this.unsavedChanges);
        for (let i = 0; i < keys.length; i++) {
          if (this.unsavedChanges[keys[i]]) {
            count++;
          }
        }
        return count;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      fetchAll() {
        this.isLoading = true;
        Promise.all([
          this.fetchCyclopedia(),
        ]).then(() => {
          this.isLoading = false;
        });
      },
      async fetchCyclopedia() {
        const cyclopedia = await api.fetchCyclopedia(this.cyclopediaId);
        this.setCyclopediaCopies(cyclopedia);
      },
      setCyclopediaCopies(cyclopedia) {
        this.cyclopedia = cyclopedia;
        this.workingCyclopedia = new types.Cyclopedia(this.cyclopedia);
      },
      async updateCyclopedia() {
        await api.updateCyclopedia({
          id: this.workingCyclopedia.id,
          active: this.workingCyclopedia.active
        });
      },
      confirmDeleteCyclopedia() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${this.cyclopedia.name}`,
          text: `Are you sure you want to delete this book?`,
          accept: () => {
            this.deleteCyclopedia(this.cyclopedia);
          }
        })
      },
      async deleteCyclopedia() {
        const success = api.deleteCyclopedia(this.cyclopedia);
        if (!success) {
          this.showNotification(false, 'error deleting rank');
          return;
        }

        this.showNotification(true, `Book/title "${this.cyclopedia.name}" Deleted`);
        this.$router.push(`/content/books/list`).catch(() => {
        });
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'
        });
      },
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

